import { useContext } from "react";
import { useIntl } from "react-intl";

import NavContext from "components/molecules/Navigation/components/common/NavContext";
import ProgressStep from "components/v2/ProgressSteps/ProgressStep";
import { useCreateParcelAccountContext } from "../CreateParcelAccountState";

function CreateParcelAccountHeader() {
  const intl = useIntl();
  const { navigationConfig } = useContext(NavContext);
  const { isMobile, navWidth, settingNavWidth } = navigationConfig;
  const { state } = useCreateParcelAccountContext();

  const totalNavWidth = navWidth + settingNavWidth + 1;
  const hasValidationResponse = !!state.addressValidationResponse;

  return (
    <>
      <div
        style={{
          position: isMobile ? "static" : "fixed",
          top: 0,
          left: totalNavWidth,
          width: isMobile ? "100%" : `calc(100% - ${totalNavWidth}px)`,
        }}
        className="create-parcel-account__header-container text-sm font-medium text-secondary-v2"
      >
        <div className="w-100 mr-xl text-brand-secondary">
          <ProgressStep
            title={intl.formatMessage({
              id: "settings.parcelAccounts.createAccount.stepDetailsTitle",
              defaultMessage: "Add parcel account details",
            })}
            isActive={!hasValidationResponse}
            isComplete={hasValidationResponse}
          />
        </div>
        <div className="w-100">
          <ProgressStep
            title={intl.formatMessage({
              id: "settings.parcelAccounts.createAccount.stepVerifyTitle",
              defaultMessage: "Verify your account",
            })}
            isActive={hasValidationResponse}
          />
        </div>
      </div>
      {!isMobile && <div style={{ marginTop: isMobile ? 40 : 64 }} />}
    </>
  );
}

export default CreateParcelAccountHeader;
